import { render } from "./generalLayout.vue?vue&type=template&id=57f9a738&scoped=true"
import script from "./generalLayout.vue?vue&type=script&lang=js"
export * from "./generalLayout.vue?vue&type=script&lang=js"

import "./generalLayout.vue?vue&type=style&index=0&id=57f9a738&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57f9a738"]])

export default __exports__